export default __webpack_public_path__ + "static/media/gear-bold.be7c10a2.svg";